module.exports = "mutation ($id: ID!) {\n  WebhookDelete(id: $id) {\n    id\n  }\n}\n"